import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createLaunchDarklyContext } from '@adsk/alloy-provider';
import useOxygenId from '../hooks/useOxygenId';

const {
  LaunchDarklyProvider: AdminLaunchDarklyProvider,
  SimpleLaunchDarklyProvider,
  useFeatureFlag: useAdminFeatureFlag,
  useAllFeatureFlags: useAdminAllFeatureFlags,
} = createLaunchDarklyContext();

const AdminPublicLaunchDarklyProvider = ({ apiKey, children }) => {
  const { oxygenId: currentOxygenId } = useOxygenId();

  const user = useMemo(() => {
    if (!currentOxygenId) return null;

    return { key: currentOxygenId };
  }, [currentOxygenId]);

  return (
    <SimpleLaunchDarklyProvider apiKey={apiKey} user={user}>
      {children}
    </SimpleLaunchDarklyProvider>
  );
};

AdminPublicLaunchDarklyProvider.defaultProps = {
  children: null,
};

AdminPublicLaunchDarklyProvider.propTypes = {
  apiKey: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export {
  AdminLaunchDarklyProvider,
  AdminPublicLaunchDarklyProvider,
  useAdminFeatureFlag,
  useAdminAllFeatureFlags,
};
